module.exports = __webpack_public_path__ + "media/service-types.fc1dad36.mp4";